const artistStreamsByMonths = [
  {
    id: 1,
    artist_id: 1,
    streams_count: 500,
    date: "01-10-2025",
  },
  {
    id: 1,
    artist_id: 2,
    streams_count: 500,
    date: "01-08-2025",
  },
  {
    id: 1,
    artist_id: 1,
    streams_count: 500,
    date: "01-01-2025",
  },
  {
    id: 1,
    artist_id: 1,
    streams_count: 500,
    date: "01-11-2025",
  },
];

const getStreamsForCurrentMonthByArtistId = (artistId) => {
  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
  const currentYear = currentDate.getFullYear();

  const currentMonthEntry = artistStreamsByMonths.find((entry) => {
    const entryDate = new Date(entry.date);
    const entryMonth = String(entryDate.getMonth() + 1).padStart(2, '0');
    const entryYear = entryDate.getFullYear();

    return (
      entry.artist_id === artistId &&
      entryMonth === currentMonth &&
      entryYear === currentYear
    );
  });

  return currentMonthEntry ? { streams_count: currentMonthEntry.streams_count } : 0;
};

export { getStreamsForCurrentMonthByArtistId };